export default __webpack_public_path__ + "static/media/zoom.dd85b577.png";